import { render } from "./SignInPage.vue?vue&type=template&id=01a6b4a2"
import script from "./SignInPage.vue?vue&type=script&lang=js"
export * from "./SignInPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Teh/Dev/web/loop-client-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__